























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixin, Mixins } from 'vue-mixin-decorator'
import LanderMixin from '@/mixins/LanderMixin'; // @ is an alias to /src
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import lander001 from '@/landers/lander001.vue';             // @ is an alias to /src
import lander002 from '@/landers/lander002.vue';             // @ is an alias to /src
import lander003 from '@/landers/lander003.vue';             // @ is an alias to /src
import lander004 from '@/landers/lander004.vue';             // @ is an alias to /src
import landerPricing from '@/landers/landerPricing.vue';     // @ is an alias to /src

interface fbComment { story_fbid: number, id: number, comment_id: number }

@Component({
  name: 'Lander',
  components: { 
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
    FBCommentsComponent: () => import('@/components/FBCommentsComponent.vue'),
    LanderStepsComponent: () => import('@/components/LanderStepsComponent.vue'),
    UrgencyAndSignUpButtonComponent: () => import('@/components/UrgencyAndSignUpButtonComponent.vue'),
    landerPricing
   }
})


export default class LanderView extends Mixins<LanderMixin>(LanderMixin) {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }

  public landerId: string = null
  public landerComponent: typeof lander001 | typeof lander002 | typeof lander003 | typeof lander004 = null
  public email: string = null
  
  public showSignUp: boolean = true

  public userClickedCTA(): void {
    if (this.optimizeForFacebook()) this.userChoseFacebookLogin();
    else this.userChoseRegister()
  }

  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as any).show('Sign Up to StoryCircle', 'sm', null)
  }

  public userChoseFacebookLogin(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (window as any).analytics.track('User ClickedFBLogin')
    this.$fb.login()
  }

  // lifecycle hooks
  public created() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} created()`)
    this.setStuffFromPath()
  }

  public mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private setStuffFromPath() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} setStuffFromPath()`, this.utm_source, this.utm_campaign, this.utm_medium, this.utm_content)

    this.landerId = this.$route.params.id;
    const passedInTitle: string = this.$route.query.t as string;  // not using this in the wild, but we could

    switch (this.landerId) {
      case '101':
        this.title = passedInTitle || '"Give your children the gift of listening to your life memories, whenever and wherever they want."';
        this.landerComponent = lander001;
        this.signUpText = '3 Easy Steps to Preserve Your Memories',
        this.image = 'pretty-woman-older-dad-974x450-50.jpg'
        this.urgencyText = '<b>Free spaces are limited</b> so please sign up now.'
        this.buttonCTA = 'Sign Up Now!'
        break;
      case '215':
        this.title = passedInTitle || '"What would you give to hear a loved one’s voice again?"';
        this.landerComponent = lander002;
        this.signUpText = '3 Easy Steps to Share Your Own Stories',
        this.image = 'pretty-woman-older-dad-974x450-50.jpg'
        this.urgencyText = '<b>Free spaces are limited</b> so please sign up now.'
        this.buttonCTA = 'Sign Up Now!'
        break;
      case '308':
        this.title = passedInTitle || '"What would you give to hear a loved one’s voice again?"';
        this.landerComponent = lander003;
        this.signUpText = '3 Easy Steps to Share Your Own Stories',
        this.image = 'video/whiteboard_keymanj'
        this.urgencyText = '<b>Free spaces are limited</b> so please sign up now.'
        this.buttonCTA = 'Sign Up Now!'
        break;
      case '216':
        this.title = passedInTitle || '"What would you give to hear a loved one’s voice again?"';
        this.landerComponent = lander004;
        this.image = 'pretty-woman-older-dad-974x450-50.jpg'
        this.showSignUp = false
        break;
       default: this.title = null
    }

    // switch image based on what ad showed
    this.setImageBasedOnUTMContent();

    // randomly choose if we show pricing
    if (Math.random() < 0.5) this.showPricing = true; else this.showPricing = false;

    // for funnel conversion tracking
    (window as any).analytics.track('Lander Viewed', { landerId: this.landerId, title: this.title, image: this.image, buttonCTA: this.buttonCTA, showFbComments: this.showFbComments, showFBLogin: this.$fb.useFbLoginRandomAB, showPricing: this.showPricing });

  }

  // this is necessary because path changes don't reload the component nor its subcomponents
  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`${this.$options.name} pathChanged()`)
    this.setStuffFromPath()
  }


}

